import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPaginatedResponse } from '@boma/supplier-portal/shared/entities';

@Component({
  selector: 'boma-pagination',
  templateUrl: './boma-pagination.component.html',
  styleUrls: ['./boma-pagination.component.scss'],
})
export class BomaPaginationComponent implements OnInit {
  @Input() pageSize: number;
  @Input() results: IPaginatedResponse<any>;
  @Input() tableName = '';
  @Output() updatePage = new EventEmitter();
  @Output() refreshPage = new EventEmitter();
  @Output() searchEvent = new EventEmitter();
  @Output() updatePageSize = new EventEmitter();

  pageSizes = [10, 25, 50, 100];

  constructor() {}

  ngOnInit(): void {
    console.log(this.results);
  }

  changePage(pageNumber) {
    this.updatePage.emit(pageNumber);
  }

  handlePageSize(page: {value: number}) {
    this.updatePageSize.emit(page.value);
  }

  refresh() {
    this.refreshPage.emit();
  }

  search() {
    this.searchEvent.emit();
    // we got to do a search thing here, dialogue that pulls in a a template from the parent?
  }
}
